import { Link } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import {
  ScaffoldSection,
  ScaffoldSectionContainer,
  ScaffoldSectionContent,
  ScaffoldSectionHeader,
  ScaffoldSectionTitle,
} from "./scaffold";

export function GroupBooking() {
  return (
    <ScaffoldSection
      className="bg-accent text-accent-foreground"
      id="gruppenbuchung"
    >
      <ScaffoldSectionContainer>
        <ScaffoldSectionHeader>
          <ScaffoldSectionTitle>
            Ein Abend, viele Möglichkeiten
          </ScaffoldSectionTitle>
        </ScaffoldSectionHeader>
        <ScaffoldSectionContent>
          <p className="text-center text-base">
            Ob Firmenfeier, Hochzeit oder ein Abend mit Freunden - in der Alten
            Papierfabrik gestalten Sie unvergessliche Erlebnisse. Kombinieren
            Sie Bowling, 3D-Schwarzlicht-Minigolf, die Sportsbar und das Aposto
            Restaurant für einen einzigartigen Eventabend. Stellen Sie Ihre
            Wunschkombination zusammen und feiern Sie nach Ihren Vorstellungen.
          </p>
          <Button
            asChild
            className="w-fit border-4 border-accent-foreground"
            size="xl"
            variant="unstyled"
          >
            {/* <Link to="/buchen/gruppe">Zur Gruppenbuchung</Link> */}
            <a href="mailto:buchen@altepapierfabrik.eu">Jetzt anfragen</a>
          </Button>
        </ScaffoldSectionContent>
      </ScaffoldSectionContainer>
    </ScaffoldSection>
  );
}
